// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation-NAKL1uDO clearfix"};